/* Consent gate for embedded YouTube videos (shared by the abensberg and
   gillamoos bundles).

   Templates render a [data-youtube-embed] placeholder (see
   templates/partials/youtube-consent.html.twig) instead of the iframe. The
   Klaro "youtube" service callback (public/consent/config.js and the inline
   config in abensberg.html.twig) sets window.youtubeConsentGiven and fires
   "abensberg:youtube-consent"; once consent exists — from the stored cookie,
   the Klaro modal, or the placeholder's allow button — every placeholder on
   the page is swapped for the real iframe. The allow button also persists
   the choice through the Klaro manager so it survives page loads. */

function buildIframe(el) {
    const id = el.dataset.youtubeId;
    if (!id) return;
    const iframe = document.createElement('iframe');
    iframe.className = 'absolute inset-0 w-full h-full';
    iframe.title = el.dataset.youtubeTitle || 'YouTube Video';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id);
    el.replaceChildren(iframe);
}

function grantYoutubeConsent() {
    // Klaro v0.3.3: getManager() falls back to the config captured at
    // klaro.js load time and throws if that's missing, so guard everything.
    try {
        const klaro = window.klaro;
        const manager = klaro && klaro.getManager && klaro.getManager(window.klaroConfig || undefined);
        if (manager) {
            manager.updateConsent('youtube', true);
            manager.saveAndApplyConsents();
        }
    } catch (e) {
        // Klaro missing or blocked — still show the video for this page view.
    }
}

export function initYoutubeConsent() {
    // Footer "Cookie-Einstellungen" links open the Klaro modal.
    document.querySelectorAll('[data-klaro-toggle]').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            if (window.klaro && window.klaro.show) window.klaro.show();
        });
    });

    const embeds = Array.from(document.querySelectorAll('[data-youtube-embed]'));
    if (!embeds.length) return;

    let loaded = false;
    const loadAll = () => {
        if (loaded) return;
        loaded = true;
        embeds.forEach(buildIframe);
    };

    document.addEventListener('abensberg:youtube-consent', (event) => {
        if (event.detail && event.detail.consent) loadAll();
    });
    if (window.youtubeConsentGiven) loadAll();

    embeds.forEach((el) => {
        const accept = el.querySelector('[data-youtube-accept]');
        if (accept) {
            accept.addEventListener('click', () => {
                grantYoutubeConsent();
                loadAll();
            });
        }
        const settings = el.querySelector('[data-youtube-settings]');
        if (settings) {
            settings.addEventListener('click', () => {
                if (window.klaro && window.klaro.show) window.klaro.show();
            });
        }
    });
}
